import { Image } from "../images/Image/Image";
import { CardTitle } from "../text/CardTitle/CardTitle";
import { CartSubtitle } from "../text/CartSubtitle/CartSubtitle";
import "./ProductHeader.css";

interface ProductHeaderProps {
  image?: string;
  name: string;
  productType: string;
  collection: string;
}

export const ProductHeader = ({
  image,
  name,
  productType,
  collection,
}: ProductHeaderProps) => {
  return (
    <div className="product-header">
      <Image width="5rem" image={image} />
      <div className="product-info">
        <CardTitle title={name} margin="0" />
        <CartSubtitle text={productType} opacity={0.5} />
        <CartSubtitle text={collection} />
      </div>
    </div>
  );
};
